import { toDataURL } from 'network';
import { arraysEqual } from 'utilities/data';
import { PLAYER_EVENT } from 'constants/events';
import { BaseAnnotation } from './base_annotation';
import { isoCodeToName } from 'constants/iso_languages';


export class ClosedCaptionsAnnotation extends BaseAnnotation {
    constructor(props) {
        super(props);

        this.eventBus.onReplay(PLAYER_EVENT.AVAILABLE, (player, adapter) => {
            this.player = adapter;
            this.forceUpdate();
        });

        this.eventBus.on(PLAYER_EVENT.MEDIA_CHANGE, () => this.forceUpdate());
    }

    shouldComponentUpdate(nextProps) {
        const nextLanguages = this.findAvailableLanguages(nextProps),
            currentLanguages = this.findAvailableLanguages(this.props);

        return (
            !arraysEqual(nextLanguages, currentLanguages) ||
            nextProps.content !== this.currentSrc
        )
    }

    render() {

        if (this.player) {
            this.availableLanguages.forEach(language => {
                if (language.format === 'string') {
                    language.src = toDataURL(language.src, { type: 'text/vtt' });
                }

                const trackSettings = this.addTrackSettings(language);

                this.player.addCaptions(trackSettings, trackSettings.language === this.currentLanguage);
            })
        }

        return null;
    }

    addTrackSettings({ src, language = 'en' }) {
        const label = isoCodeToName(language);

        return {
            src,
            label,
            language,
            kind: 'captions'
        }
    }

    get availableLanguages() {
        const languages = this.findAvailableLanguages(this.props);

        return (
            languages
                .map(language => (
                        language === this.currentLanguage ?
                            {
                                src: this.currentSrc,
                                format: this.currentFormat,
                                language: this.currentLanguage
                            } : { src: null, format: 'url', language }
                    )
                )
        )
    }

    findAvailableLanguages(props = {}) {
        const languages = this.props.data && this.props.data.project && this.props.data.project.languages;
        return languages || [];
    }

    get currentLanguage() {
        return this.props.data && this.props.data.state && this.props.data.state.language || 'en';
    }

    get currentSrc () {
        return this.props.content;
    }

    get currentFormat() {
        return this.props.contentType || 'string';
    }
}